import { useQuery } from "@tanstack/react-query";
import {
  AssignmentUserBasicsDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { isEmpty } from "lodash";

import { DOMAIN_QUESTIONS_ASSIGNMENT } from "../domain";

import { questionsAssignmentApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_ASSIGNABLE_USERS = "GET_ASSIGNABLE_USERS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

interface GetAssignableUsersRequest {
  companyIds: string[];
}

const getAssignableUsers = async (
  params: GetAssignableUsersRequest,
): Promise<AssignmentUserBasicsDto[]> => {
  const { companyIds } = params;

  const response =
    await questionsAssignmentApi.assignmentsConfigControllerGetAssignableUsers(
      companyIds,
    );

  return response.data;
};

export const useGetAssignableUsers = (
  user: UserProfileDto | null,
  params: GetAssignableUsersRequest,
  enable: boolean = false,
): {
  assignableUsers?: AssignmentUserBasicsDto[];
  assignableUsersEnabled: boolean;
  isPendingGetAssignableUsers: boolean;
  isLoadingGetAssignableUsers: boolean;
  isSuccessGetAssignableUsers: boolean;
} => {
  const enabled =
    enable && !isEmpty(params.companyIds) && roleGuard(user, allowedRoles);
  const { isPending, data, isLoading, isSuccess } = useQuery({
    queryKey: [DOMAIN_QUESTIONS_ASSIGNMENT, ACTION_GET_ASSIGNABLE_USERS, params],
    queryFn: () => getAssignableUsers(params),
    enabled: enabled,
    staleTime: TANSTACK_QUERY_STALE_TIME,
  });

  return {
    assignableUsers: data,
    assignableUsersEnabled: enabled,
    isPendingGetAssignableUsers: isPending,
    isLoadingGetAssignableUsers: isLoading,
    isSuccessGetAssignableUsers: isSuccess,
  };
};
